import { Format } from './format.interface';
import { Card, Query } from '@deckplan.io/common';

export class Pioneer extends Format {

    public addCardsQuery(): Query {
        return {
            dataField: {
                title: 'Legalities',
                field: 'legalities',
                dataType: 'string'
            },
            operation: 'includes',
            value: `"pioneer":"legal"`
        };
    }

    public validate(): Card[] {
        return this.deck.cards.filter(c =>
            // All cards not legal in pioneer are invalid
            c.legalities.pioneer === 'not_legal'
        );
    }

}
